import Vue from 'vue';
import Router from 'vue-router';
import { routers } from './router';
import CommonUtils from '@/resources/utils/common-utils';
import iView from 'iview';
import {FetchSimulateInfo} from '@/store/modules/common'
import store from '@/store'

Vue.use(Router);
Vue.use(iView);

const RouterConfig = {
  routes: routers
};

export const router = new Router(RouterConfig)
router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();

  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  if (to.name === 'login' && to.query) {
    // let jobNo = to.query.job_no
    let _sign = to.query._sign
    if (_sign) {
      window.localStorage.removeItem('userInfo')
      // store.dispatch('loginOut')
      console.log('模拟登录先清除已有的token')
      store.commit('FetchSimulateInfo', {
        params: to.query,
        successFunc: (res) => {
          console.log('模拟登录成功', res)
          window.localStorage.setItem('userInfo', JSON.stringify(res.data))
          next('/home')
        },
        failFunc: (err) => {
          console.log('模拟请求失败', err)
        }
      })
    } else if (userInfo) {
      next('/home')
    }
  }
  // if (userInfo) {
  //   const devList = []
  //   userInfo.permissions = userInfo.permissions.concat(devList)
  // }
  if (userInfo && to.path !== '/home' && to.path !== '/login' && to.name !== 'not-found' && to.name !== 'forbidden' && to.path !== '/website-preview') {
    let isExistPermission = false
    userInfo.permissions.forEach(permissionItem => {
      const access_name = to.meta.access_name;
      if (!!~access_name.indexOf('|')) {
        let access_name_array = access_name.split('|');
        for (let i = 0; i < access_name_array.length; i++) {
          if (access_name_array[i] === permissionItem) {
            isExistPermission = true
            break;
          }
        }
      } else {
        if (permissionItem === access_name) {
          isExistPermission = true
        }
      }
    });

    if (!isExistPermission && from.path == '/forbidden') {
      next('/forbidden-new')
    }else if(!isExistPermission){
      next('/forbidden')
    }
  }


  if (userInfo && to.path === '/login') {
    next('/');
  }
  if (!userInfo && to.path !== '/login') {
    next('/login');
  }
  if (to.meta.hasOwnProperty('title')) {
    CommonUtils.setTitle(to.meta.title);
  }
  next();
});

router.afterEach((to) => {
  iView.LoadingBar.finish();
});



// WEBPACK FOOTER //
// ./src/router/index.js